import React, { useCallback, useEffect, useRef, useState } from 'react';
import './meeting-animation.css';
import { MeetingAnimation } from '../../../animations/meetings-animation';
import { Timer } from '../../../components/timer';

const MeetingAnimationScreen = props => {
    const { meetingDuration, completeAnimation } = props;

    const [meetingsDurationTimer, setMeetingsDurationTimer] = useState(0);
    const meetingsAnimation = useRef(new MeetingAnimation());
    const meetingsDurationTimerRef = useRef(null);

    const initialiseCanvas = useCallback(ref => {
        if (ref !== null) {
            meetingsAnimation.current.initialise('meetingCanvas');
        }
    }, []);

    useEffect(() => {
        if (meetingsDurationTimerRef.current === null) {
            meetingsDurationTimerRef.current = setInterval(() => {
                setMeetingsDurationTimer(timer => timer + 1);
            }, 1000);
        }
        return () => {
            clearInterval(meetingsDurationTimerRef.current);
        };
    }, []);

    useEffect(() => {
        if (meetingsDurationTimer === meetingDuration) {
            completeAnimation();
            const destroyStageTimeout = setTimeout(() => {
                meetingsAnimation.current.destroy();
            }, 1500);
            return () => clearTimeout(destroyStageTimeout);
        }
    }, [completeAnimation, meetingDuration, meetingsDurationTimer]);

    return (
        <div className="meeting-animation">
            <canvas
                ref={initialiseCanvas}
                id="meetingCanvas"
                className="meeting-animation__canvas"
                height="400"
                width="800"
                aria-label="meeting animation"
            />
            <div className="meeting-animation__timer">
                <Timer
                    maxTime={meetingDuration}
                    timeElapsed={meetingsDurationTimer}
                    orientation="horizontal"
                    countUp
                />
            </div>
        </div>
    );
};

export { MeetingAnimationScreen };
